// FD-1186: keep a work item's activity feed on the tab the reader picked across a page refresh.
//
// The feed's lazy frame (work_items/_activity_feed) carries refresh: "morph", so a same-URL
// refresh (every property edit is a redirect_back; a broadcast refresh is one too) leaves the
// loaded feed in place and reloads it. Turbo only does that while the frame's CURRENT src
// matches the src the incoming page renders for it. The tab links navigate the frame to
// `…/activity?activity_tab=…`, which the page itself never renders, because the page URL does
// not change. So after a tab switch Turbo morphed the frame like any other element, back to
// its "Loading activity…" placeholder: the feed vanished, the pane's scroll position was
// clamped, and the feed came back on the All tab.
//
// Carry each feed frame's current src into the incoming page, so Turbo sees the same frame on
// the same URL and reloads it in place, on the tab the reader is on. A feed inside a dialog
// (the detail modal, which repeats the frame id) is skipped: modal_controller keeps an open
// dialog out of the morph, and its tab must not overwrite the page's.
const FEED_FRAMES = "turbo-frame[id^='activity_feed_'][refresh='morph'][src]"

document.addEventListener("turbo:before-render", (event) => {
  const { newBody, renderMethod } = event.detail
  if (renderMethod !== "morph" || !newBody) return

  document.querySelectorAll(FEED_FRAMES).forEach((frame) => {
    if (frame.closest("dialog")) return
    const incoming = newBody.querySelector(`turbo-frame#${CSS.escape(frame.id)}[refresh='morph'][src]`)
    if (incoming) incoming.setAttribute("src", frame.src)
  })
})
